import { Box, Dialog, DialogActions, DialogTitle, Grid } from "@material-ui/core";
import i18next from "i18next";
import React, { MouseEventHandler } from "react";
import ButtonConfirmDecouple from "components/buttons/primary-buttons/ButtonConfirmDecouple";
import ButtonCancel from "components/buttons/secondary-buttons/ButtonCancel";
import ButtonExitModal from "components/buttons/secondary-buttons/ButtonExitModal";
import "./confirmation-unlink-modal.scss";

type Props = {
    open: boolean;
    onClose: MouseEventHandler;
    onDecouple: MouseEventHandler;
};

const ConfirmationUnlinkDialog = ({ open, onClose, onDecouple }: Props): React.ReactElement => {
    return (
        <Box>
            <Dialog
                disableEnforceFocus
                open={open}
                onClose={onClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    <ButtonExitModal onClose={onClose} />
                </DialogTitle>
                <DialogTitle>
                    <Grid container justifyContent="center" className="dialog-info-text">
                        <Grid item xs />
                        <Grid item xs={9}>
                            {i18next.t("Modal.InfoText")}
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </DialogTitle>

                <DialogActions className="dialog-action-btns">
                    <ButtonConfirmDecouple onDecouple={onDecouple} />
                    <ButtonCancel onClose={onClose} />
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ConfirmationUnlinkDialog;
